<script lang="ts">
	//Services
	import { format } from 'svelte-i18n';
	//Svelte
	import { push, location, params } from 'svelte-spa-router';
	//Stores
	import { extended_dashboards } from 'src/stores/features/dashboards';
	//Components
	import DashWizard from 'src/components/Dashboards/DashWizard/DashWizard.svelte';
	//Helpers
	import { capFirstChar } from '../../../helpers/utilities';
	import { checkIsEventLogTab, sortByPosition } from 'src/components/Lists/list-helpers';
	import type {
		DashWidgetEditType,
		DashWizardInitialStep,
	} from 'src/components/Dashboards/dash-types';
	import { resolveDashboardId } from 'src/components/Dashboards/dash-helpers';
	import { getEnergyDashboardRouteSegment } from 'src/components/EnergyMonitoring/helpers/energy-dashboard-settings';

	export let routeParams: {
		type: string;
		id: string;
	};
	export let showModal: boolean;
	export let dashEditItem: DashWidgetEditType | undefined;
	export let editColumn: 'left' | 'right' | undefined;
	export let hideSelectDash = false;
	export let isAddWizard = false;
	export let dashboardId: string | number | undefined;
	export let initialEnergyWidget = false;
	export let energyOnly = false;
	export let initialStep: DashWizardInitialStep | undefined;

	const DEFAULT_DASH_ID = -1;

	$: resolvedDashboardId = resolveDashboardId({
		explicitId: dashboardId ?? dashEditItem?.dashboardId,
		paramsId: $params?.id,
		location: $location,
	});

	let editItem: DashWidgetEditType = {
		id: dashEditItem?.id || '',
		dashboardId: dashEditItem?.dashboardId || DEFAULT_DASH_ID,
		col: dashEditItem?.col || 'left',
		position: dashEditItem?.position ?? null,
		widgetTitle: dashEditItem?.widgetTitle || '',
		showWidgetTitle: dashEditItem?.showWidgetTitle ?? true,
		widgetType: dashEditItem?.widgetType || (initialEnergyWidget ? 'dashEnergyInfo' : ''),
		selectItems: dashEditItem?.selectItems || [],
		cameraConfig: dashEditItem?.cameraConfig,
		energyConfig: dashEditItem?.energyConfig,
		widgetsCounter: 0,
	};

	let updatedItem: { type: string; id: any } = {
		type: '',
		id: -1,
	};

	$: if (initialEnergyWidget && showModal && !editItem.widgetType) {
		editItem = {
			...editItem,
			widgetType: 'dashEnergyInfo',
		};
	}

	$: if (editColumn) {
		editItem = {
			...editItem,
			col: editColumn,
		};
	}

	$: list =
		$extended_dashboards?.[resolvedDashboardId]?.sort(sortByPosition).map((el) => {
			if (checkIsEventLogTab(el)) {
				el.text = capFirstChar($format(el.text));
			}

			return el;
		}) || [];

	$: (resolvedDashboardId, (editItem.dashboardId = resolvedDashboardId));

	const onDashWidgetSaved = () => {
		const numericRoute = `/dash/${editItem.dashboardId}`;
		const semanticSegment = getEnergyDashboardRouteSegment(Number(editItem.dashboardId));
		const targetRoute = semanticSegment ? `/dash/${semanticSegment}` : numericRoute;

		if (!$location.includes(targetRoute) && !$location.includes(numericRoute)) {
			push(targetRoute);
		}
	};
</script>

<DashWizard
	{hideSelectDash}
	bind:showAddEditModal={showModal}
	bind:editItem
	items={list}
	bind:updatedItem
	on:afterAddWidget={onDashWidgetSaved}
	on:close
	{isAddWizard}
	{energyOnly}
	{initialStep}
/>
